// Columns for the tables
const columns = [
  { field: "IssueType", headerName: "Issue Type", width: 145 },
  { field: "IssueKey", headerName: "Issue Key", width: 140 },
  { field: "IssueSummary", headerName: "Issue Summary", width: 400 },
  { field: "IssueStatus", headerName: "Issue Status", width: 160 },
  { field: "Component", headerName: "Component", width: 150 },
  { field: "ReleaseNotes", headerName: "Release Notes", width: 900 },
];

export default columns;
